<template lang="pug">
v-container.View.View--Profile
  template(v-if="!loading")
    v-card
      v-card-text
        v-layout(column)
          .eyelet.text-uppercase Profilo
          .title.mb-3 Ciao {{ user.name }} {{ user.surname }}, bentornato!
          v-layout.mb-2(wrap data-cy="container_informations")
            v-flex(xs6)
              | Nome:
              .d-inline.body-2.ml-1 {{ user.name }}
            v-flex(xs6)
              | Cognome:
              .d-inline.body-2.ml-1 {{ user.surname }}
            v-flex(xs12)
              | Email:
              .d-inline.body-2.ml-1 {{ user.email }}
            v-flex(xs12 v-if="user.phone")
              | Telefono:
              .d-inline.body-2.ml-1 {{ user.phone }}
          v-layout(align-center justify-center)
            v-btn(color='primary' text :to='{name: "profile.edit"}') Modifica profilo
            v-btn(@click="logout()") Logout
          v-flex.mx-2.mt-4.text-center(xs12)
    v-card.mt-3(:to="{ name:'profile.reservations' }" data-cy="button_reservations")
      v-card-text.text-center
        v-icon.px-3.font-size-xl(color="black") mdi-ticket
        .title.grey--text.text--darken-3 Prenotazioni
  template(v-else)
    Loading
</template>

<script>
import Loading from "@/components/Loading";
import User from "@/api/User";

export default {
  name: "Profile",
  components: { Loading },
  data: function() {
    return {
      loading: true,
      user: null
    };
  },
  async mounted() {
    this.loading = true;
    this.$emit("update:title", "Profilo");
    this.user = await User.getProfile();
    this.loading = false;
  },

  methods: {
    logout() {
      this.$auth.logout();
      this.$emit("logout");
    }
  }
};
</script>
